import React from "react";
import { Spinner, Center } from "@astryxdesign/core";
import styles from "./ContentContainer.module.css";

export type ContentContainerVariant = "default" | "sidebar";

export interface ContentContainerProps {
  children: React.ReactNode;
  variant?: ContentContainerVariant;
  loading: boolean;
}

/**
 * Content container using Astryx's Spinner component.
 *
 * The loading state uses astryx.Spinner (centered via astryx.Center) instead
 * of the custom react-icons LoadingSpinner, so this MUST be rendered inside
 * an Astryx <Theme> scope.
 */
const ContentContainer = ({
  children,
  variant = "default",
  loading,
}: ContentContainerProps): React.ReactElement => {
  const classes = [styles.container, variant === "sidebar" ? styles.sidebar : ""]
    .filter(Boolean)
    .join(" ");

  // If loading, render the spinner. Otherwise, render the contents.
  const subRender = loading ? (
    <Center padding={8}>
      <Spinner size="lg" />
    </Center>
  ) : (
    children
  );

  return (
    <div className={styles.flexWrapper}>
      <div className={classes}>{subRender}</div>
    </div>
  );
};

export default ContentContainer;
